/**
 * Header Layout
 *
 * @file header.js
 */


const header = (() => {
  const fixedHeader = () => {
    document.addEventListener("scroll", function () {
      const header = document.querySelector("header");
      if(header){
        if (window.scrollY >= 84) {
          header.classList.add("fixed_header");
        } else {
          header.classList.remove("fixed_header");
        }
      }
    });
  };

  const headerMegaMenu = () => {
    document.addEventListener('DOMContentLoaded', () => {
      const menuItems = document.querySelectorAll('.header-container .menu ul li a');
      const header = document.querySelector('header');
      const headerTopShadow = document.querySelector('.header-fixed-shadow');

      menuItems.forEach(item => {
        const megaMenu = item.nextElementSibling;

        item.addEventListener('mouseenter', () => {
          const rect = item.getBoundingClientRect();
          const positionFromLeft = rect.left + window.scrollX;
          const headerOffset = item.closest('.header-container').getBoundingClientRect().left + window.scrollX;
          const positionRelativeToHeader = positionFromLeft - headerOffset;
          const adjustedPosition = positionRelativeToHeader + (rect.width / 2);

          if (megaMenu && megaMenu.classList.contains('mega-menu')) {
            const triangle = megaMenu.querySelector('.triangle');
            if (triangle) {
              triangle.style.left = `${adjustedPosition}px`;
            }
            header.classList.add('header-shadow-open-2');
            headerTopShadow.classList.add('active');

            setTimeout(() => {
              megaMenu.classList.add('loading-remove');
            }, 500);
          }
        });

        item.addEventListener('mouseleave', () => {
          if (megaMenu && !megaMenu.matches(':hover')) {
            header.classList.remove('header-shadow-open-2');
            headerTopShadow.classList.remove('active');
          }
        });
      });

      const megaMenus = document.querySelectorAll('.mega-menu');
      megaMenus.forEach(megaMenu => {
        megaMenu.addEventListener('mouseenter', () => {
          header.classList.add('header-shadow-open-2');
          headerTopShadow.classList.add('active');
        });

        megaMenu.addEventListener('mouseleave', () => {
          header.classList.remove('header-shadow-open-2');
          headerTopShadow.classList.remove('active');
        });

        const items = megaMenu.querySelectorAll('.item');
        const images = megaMenu.querySelectorAll('.mega-menu-item-img .img');

        items.forEach((item, index) => {
          item.addEventListener('mouseenter', () => {
            images.forEach(img => img.classList.remove('active'));
            if (images[index]) {
              images[index].classList.add('active');
            }
          });

          item.addEventListener('mouseleave', () => {
            // Fare ayrıldığında active sınıfını kaldır
            if (images[index]) {
              // images[index].classList.remove('active');
            }
          });
        });
      });

      const megaMenuListItems = document.querySelectorAll(".mega-menu-item");
      megaMenuListItems.forEach(megaMenuListItem => {
        const imgElementsContainer = megaMenuListItem.nextElementSibling; 
        const imgElements = imgElementsContainer.querySelectorAll(".img");
        const imgElement = imgElementsContainer.querySelector(".img");


        megaMenuListItem.addEventListener('mouseleave', () => {
          if (imgElements.length > 0) {
            // imgElements[0].classList.remove("active");
            // console.log("Active sınıfı kaldırıldı:", imgElements[0]);
          }
          // megaMenuListItem.nextElementSibling.querySelector(".img").classList.add("active");
        });

        megaMenuListItem.addEventListener('mouseenter', () => {
          imgElements.forEach(img => img.classList.remove("active"));
          if (imgElements.length > 0) {
            // imgElements[0].classList.add("active");
            // console.log("Active sınıfı eklendi:", imgElements[0]);
          } else {
            // console.log("Hiç img öğesi bulunamadı.");
          }
          // megaMenuListItem.nextElementSibling.querySelector(".img").classList.remove("active");
          // megaMenuListItem.nextElementSibling.querySelectorAll(".img").forEach(img => {
          //   img.classList.remove("active");
          // });
        });
      });
      
      $(".mega-menu-item").hover(function(){
      },function(){
        $(this).next(".mega-menu-item-img").find(".img").removeClass("active");
        $(this).next(".mega-menu-item-img").find(".img:eq(0)").addClass("active");
      })
    });
  };

  const headerSearchBtn = () => {
    const searchButton = document.querySelector('.header-top-search .search-btn');
    const header = document.querySelector('header');
    const searchInput = document.querySelector('.full-screen-search-inp input');
    const fullScreenSearch = document.querySelector('.full-screen-search');
    const fullScreenSearchOverlay = document.querySelector('.full-screen-search-overlay');
    const fullScreenSearchClose = document.querySelector('.full-screen-search-close');
    const headerTopShadow = document.querySelector('.header-fixed-shadow');
    // const headerTopNotification = document.querySelector('.header-top-notification');
    const hamburgerMenu = document.querySelector(".mobile-hamburger-menu");
    const openHamburgerMenu = document.querySelector(".mobile-menu");
    if(searchButton){
      searchButton.addEventListener('click', function (event) {
        // header.classList.add('header-search-open', 'header-shadow-open');
        fullScreenSearch.classList.add("active");
        searchInput.focus();
        // document.documentElement.classList.add("overflow-hidden", "h-dvh");
        document.body.classList.add("overflow-hidden", "h-dvh");
        // headerTopShadow.classList.add("active","cursor");
        // hamburgerMenu.classList.remove("active");
        // openHamburgerMenu.classList.add("hidden");
      });
      fullScreenSearchOverlay.addEventListener('click', function (event) {
        fullScreenSearch.classList.remove("active");
        document.body.classList.remove("overflow-hidden", "h-dvh");
      });
      fullScreenSearchClose.addEventListener('click', function (event) {
        fullScreenSearch.classList.remove("active");
        document.body.classList.remove("overflow-hidden", "h-dvh");
      });

    }

    document.addEventListener('click', function (event) {
      if(header){
        if (!header.contains(event.target) && header.classList.contains('header-search-open')) {
          header.classList.remove('header-search-open', 'header-shadow-open');
          // document.documentElement.classList.remove("overflow-hidden", "h-dvh");
          // document.body.classList.remove("overflow-hidden", "h-dvh");
          headerTopShadow.classList.remove("active","cursor");
        }
      }
    });

    if(headerTopShadow){ 
      headerTopShadow.addEventListener('click', function (event) {
        header.classList.remove('header-search-open', 'header-shadow-open', 'header-shadow-open-2');
        // document.documentElement.classList.remove("overflow-hidden", "h-dvh");
        // // document.body.classList.remove("overflow-hidden", "h-dvh");
        headerTopShadow.classList.remove("active","cursor");
      });
    }

    // headerTopNotification.addEventListener('mouseenter', function () {
    //   header.classList.add('header-notification-open', 'header-shadow-open-2');
    //   headerTopShadow.classList.add("active");
    //   hamburgerMenu.classList.remove("active");
    //   openHamburgerMenu.classList.add("hidden");
    // });

    // headerTopNotification.addEventListener('mouseleave', function () {
    //   header.classList.remove('header-notification-open', 'header-shadow-open-2');
    //   headerTopShadow.classList.remove("active");
    // });
  };

  const headerMobileHamburgerMenu = () => {
    const hamburgerMenu = document.querySelector(".mobile-hamburger-menu");
    const openHamburgerMenu = document.querySelector(".mobile-menu");
    if(hamburgerMenu){
      hamburgerMenu.addEventListener('click', function (event) {
        event.currentTarget.classList.toggle("active");
        openHamburgerMenu.classList.toggle('hidden');
        document.documentElement.classList.toggle("overflow-hidden");
        document.documentElement.classList.toggle("h-dvh");
        document.body.classList.toggle("overflow-hidden"); 
        document.body.classList.toggle("h-dvh"); 
      });
    }
  };

  const footerMobileHamburgerMenu = () => {
    document.querySelectorAll(".footer-menu-title").forEach(title => {
        title.addEventListener('click', function () {
            this.classList.toggle("active");
            if(this.nextElementSibling){
              this.nextElementSibling.classList.toggle('hidden')
            }
        });
    });
  };

  const bannerScrollBottom = () => {
    const scrollButton = document.querySelector('.home-next-section');
    if (scrollButton) { 
        scrollButton.addEventListener('click', function() {
            const aboutBanner = document.querySelector('.home-slide-container');
            if (aboutBanner) {
                const nextElement = aboutBanner.nextElementSibling;
                if (nextElement) {
                    const scrollPosition = nextElement.offsetTop - 80;
                    window.scrollTo({
                        top: scrollPosition,
                        behavior: 'smooth'
                    });
                }
            }
        });
    }
  }

  const headerTopNavi = () => {
    const headerDivs = document.querySelectorAll('.header-top-navi > div');

    headerDivs.forEach(div => {
      div.addEventListener('mouseenter', () => {
        headerDivs.forEach(otherDiv => {
          if (otherDiv !== div) {
            otherDiv.style.opacity = '0.5';
          }
        });
        div.style.opacity = '1';
      });

      div.addEventListener('mouseleave', () => {
        headerDivs.forEach(otherDiv => {
          otherDiv.style.opacity = '1';
        });
      });
    });
  };

  const footerDonateBtn = () => {
    const dnsButton = document.querySelector('.footer-donate-support-center .dns-button');
    const dnsButtonClose = document.querySelector('.footer-donate-support-center .dns-close');
    if(dnsButton){
      dnsButton.addEventListener('click', function() {
          const footerDonateSupportCenter = document.querySelector('.footer-donate-support-center');
          footerDonateSupportCenter.classList.remove('remove');
          footerDonateSupportCenter.classList.add('support-open');
          setTimeout(() => {
              footerDonateSupportCenter.classList.add('opacity');
          }, 2000);
      });
      dnsButtonClose.addEventListener('click', function() {
          const footerDonateSupportCenter = document.querySelector('.footer-donate-support-center');
          footerDonateSupportCenter.classList.remove('support-open');
          footerDonateSupportCenter.classList.remove('opacity');
          footerDonateSupportCenter.classList.add('remove');
      });
    }
  };

  const inputFileCustom = () => {
    const inputFileCustom = document.querySelector('.career-file');
    const customFileText = document.querySelector('.custom-file-text');
    if (inputFileCustom) {
      inputFileCustom.addEventListener('change', function() {
          const fileName = this.files[0]?.name || "Dosya seçilmedi";
          customFileText.textContent = fileName;
      });
    }
  };

  const init = () => {
    fixedHeader();
    headerMegaMenu();
    headerSearchBtn();
    headerMobileHamburgerMenu();
    footerMobileHamburgerMenu();
    bannerScrollBottom();
    headerTopNavi();
    footerDonateBtn();
    inputFileCustom();
  };

  return {
    init,
  };
})();

export default header;
